"use client"

import { useState, useEffect, useRef } from "react"
import { motion } from "framer-motion"
import press from "../assets/nib.jpg"
import release from "../assets/ventur.jpg"
import presss from "../assets/release.jpg"
import releases from "../assets/pr.jpg"
import Release from "../assets/press.jpg"
import styles from "../styles/PressRelease.module.css"
import { Search, ChevronLeft, ChevronRight } from "lucide-react"
import { Link } from "react-router-dom"
import Header from "../components/Header"
import Footer from "../components/Footer"
import eleventh from "../assets/eight.png"
import tenth from "../assets/sixth.png"
import ninth from "../assets/fifth.png"
import eigth from "../assets/forth.png"
import seventh from "../assets/third.png"
import sixth from "../assets/release.png"
import fifth from "../assets/press.png"
import twelveth from "../assets/nine.png"
import report from "../assets/yaya1.jpg"
import Ejat from "../assets/E-jit.jpg"
import pcidss from "../assets/pcidssAward.png"
import ArifSwitch from "../assets/ArifSwitch.png"
import arifSchoolPartnership from "../assets/ArifSchoolPartnership.jpg"
import redCloud from "../assets/recloud.png"
import micro from "../assets/micro.jpg"
import visa from "../assets/visa.jpg"
import avicom from "../assets/avicom.jpg"
import remit from "../assets/Arifremit.jpg"
import yango from "../assets/yango.jpg"


const featuredBlogPosts = [
  {
    id: 0,
    title:
      "Arifpay, in partnership with Gebeya, AIT, and EducationMatters, has officially launched ArifSchool, a comprehensive digital education ecosystem designed to modernize and transform Ethiopia's education sector.",
    imageUrl: arifSchoolPartnership,
    date: "26 May 2026",
  },
  {
    id: 1,
    title: "Arif Remit is now officially launched in Virginia, USA. The service was proudly introduced at the Grand African Run in front of thousands of Ethiopians. ",
    imageUrl: remit,
    date: "11 Oct 2025",
  },
  {
    id: 2,
    title: "   Arifpay has partnered with Yango Ethiopia. To bring smarter, faster, and seamless payments to the ride-hailing experience.",
    imageUrl: yango,
    date: "06 Oct 2025",
  },
 {
    id: 3,
    title: "The First Microfinance Summit powered by Arifpay and ETIFT wrapped up with powerful insights. ",
    imageUrl: micro,
    date: "25 Nov 2025",
  },
  {
    id: 4,
    title: "Arifpay has partnered with Visa to deploy 10,000 POS terminals across Ethiopia, bringing interoperable payments to SMEs nationwide.",
    imageUrl: visa,
    date: "19 Nov 2025",
  },
  {
    id: 5,
    title: "Arifpay and AVICOM came together at the Hyatt Regency to announce the domestic assembly of ArifPOS and Arif Dynamic QR devices.",
    imageUrl: avicom,
    date: "19 Nov 2025",
  },
  {
    id: 6,
    title: "Arifpay becomes Ethiopia's first private switch operator, authorized to act as a national payment switch",
    imageUrl: ArifSwitch,
    date: "21 Aug 2025",
  },
  {
    id: 7,
    title: "Arifpay Financial Technologies Solution has signed a strategic partnership agreement with E-jat",
    imageUrl: Ejat,
    date: "21 Aug 2025",
  },
  {
    id: 8,
    title: "NIB Bank and Arifpay Roll Out Integrated Payment Solutions Targeting Business and Merchants.",
    imageUrl: press,
    date: "21 Jun 2025",
  },
  {
    id: 9,
    title:
      "Arifpay Financial Technologies and weVentureHub signed a landmark strategic partnership aimed at empowering Ethiopia's rising entrepreneurs, creators, and tech startups.",
    imageUrl: release,
    date: "04 Jun 25",
  },
  {
    id: 10,
    title: "Digital Health Payment Initiative, Service Level Agreement (SLA) Signature Event",
    imageUrl: presss,
    date: "05 March 2025",
  },
  {
    id: 11,
    title: "Strategic Partnership between Arifpay and Arts Tv",
    imageUrl: releases,
    date: "13 Feb 25",
  },
  {
    id: 12,
    title: "We're excited to announce our collaboration with Yeneta Code",
    imageUrl: Release,
    date: "17 March 2025",
  },
  {
    id: 13,
    title: "Strategic partnership with YaYa",
    imageUrl: report,
    date: "11 Jun 25",
  },
]

const otherBlogPosts = [
  {
    id: 14,
    title: `Arifpay is taking Ethiopian football to the next level!`,
    imageUrl: fifth,
    date: "07 March 2025",
  },
  {
    id: 15,
    title: `Arifpay is glad to be part of the GDG AAU at AAiT Innovation Center!`,
    imageUrl: sixth,
    date: "10 March 2025",
  },
  {
    id: 16,
    title: `We're excited to announce our collaboration with Yeneta Code!`,
    imageUrl: seventh,
    date: "17 March 2025",
  },
  {
    id: 17,
    title: `Arifpay Proudly Represented at Kigali`,
    imageUrl: eigth,
    date: "28 March 2025",
  },
  {
    id: 18,
    title: `Arifpay at the Great Rift Valley Innovation Summit!`,
    imageUrl: ninth,
    date: "02 Feb 2025",
  },
  {
    id: 19,
    title: `Arifpay Community Visit - Pink House`,
    imageUrl: tenth,
    date: "30 Jan 2025",
  },
  {
    id: 20,
    title: `Connecting Needs: Digital Solutions for Everyone`,
    imageUrl: eleventh,
    date: "14 Dec 2024",
  },
  {
    id: 21,
    title: `Partnership with Asbeza`,
    imageUrl: twelveth,
    date: "03 Dec 2024",
  },
]

const fadeInUp = {
  hidden: { opacity: 0, y: 40 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.7, ease: "easeOut" },
  },
}

const FEATURED_POSTS_PER_PAGE = 6
const OTHER_POSTS_PER_PAGE = 6

const PressRelease = () => {
  const [featuredPage, setFeaturedPage] = useState(1)
  const [otherPage, setOtherPage] = useState(1)

  const totalFeaturedPages = Math.ceil(featuredBlogPosts.length / FEATURED_POSTS_PER_PAGE)
  const featuredStartIndex = (featuredPage - 1) * FEATURED_POSTS_PER_PAGE
  const featuredEndIndex = featuredStartIndex + FEATURED_POSTS_PER_PAGE
  const currentFeaturedPosts = featuredBlogPosts.slice(featuredStartIndex, featuredEndIndex)

  const totalOtherPages = Math.ceil(otherBlogPosts.length / OTHER_POSTS_PER_PAGE)
  const otherStartIndex = (otherPage - 1) * OTHER_POSTS_PER_PAGE
  const otherEndIndex = otherStartIndex + OTHER_POSTS_PER_PAGE
  const currentOtherPosts = otherBlogPosts.slice(otherStartIndex, otherEndIndex)

  const featuredContainerRef = useRef(null)
  const othersContainerRef = useRef(null)
  
  const isInitialFeaturedMount = useRef(true)

  useEffect(() => {
    if (isInitialFeaturedMount.current) {
      isInitialFeaturedMount.current = false
      return
    }

    if (featuredContainerRef.current) {
      featuredContainerRef.current.scrollIntoView({ 
        behavior: "smooth", 
        block: "start" 
      })
    }
  }, [featuredPage])
useEffect(() => {
  window.scrollTo({ top: 0, behavior: "instant" })
}, [])


  return (
    <div>
      <Header />

      <div className={styles.container}>
        <div className={styles.maxWidth}>
          <div className={styles.padding}>
            <div className={styles.buttons}>
              <button className={styles.activeButton}>Press Releases</button>
              <a href="/Events" style={{ textDecoration: "none" }}>
                <button className={styles.eventButton}>Events</button>
              </a>
            </div>
          </div>

          <div ref={featuredContainerRef}>
            <h2 className={styles.heading}>
              Featured Blog Posts
            </h2>
            
            <div className={styles.featuredPosts}>
              {currentFeaturedPosts.map((post) => (
                <motion.div
                  key={post.id}
                  variants={fadeInUp}
                  initial="hidden"
                  whileInView="visible"
                  viewport={{ once: true, amount: 0.2 }}
                  whileHover={{
                    scale: 1.03,
                    boxShadow: "0 10px 25px rgba(0,0,0,0.15)",
                  }}
                  className={styles.featuredPostCard}
                >
                  <img src={post.imageUrl || "/placeholder.svg"} alt={post.title} className={styles.postImage} />
                  <div className={styles.postDetails}>
                    <p className={styles.postDate}>{post.date}</p>
                    <Link to={post.link || "#"} style={{ textDecoration: "none" }}>
                      <h3 className={styles.postTitleLinks}>{post.title}</h3>
                    </Link>
                  </div>
                </motion.div>
              ))}
            </div>

            {totalFeaturedPages > 1 && (
              <div className={styles.paginationContainer}>
                <button
                  onClick={() => setFeaturedPage((prev) => Math.max(prev - 1, 1))}
                  disabled={featuredPage === 1}
                  className={styles.paginationButton}
                >
                  <ChevronLeft className="h-5 w-5" />
                  Previous
                </button>
                <span className={styles.paginationInfo}>
                  Page {featuredPage} of {totalFeaturedPages}
              </span>
                <button
                  onClick={() => setFeaturedPage((prev) => Math.min(prev + 1, totalFeaturedPages))}
                  disabled={featuredPage === totalFeaturedPages}
                  className={styles.paginationButton}
                >
                  Next
                  <ChevronRight className="h-5 w-5" />
                </button>
              </div>
            )}
          </div>

          <div ref={othersContainerRef} className={styles.othersSection}>
            <h2 className={styles.heading}>Others</h2>
            <div className={styles.othersPosts}>
              {currentOtherPosts.map((post) => (
                <motion.div
                  key={post.id}
                  variants={fadeInUp}
                  initial="hidden"
                  whileInView="visible"
                  viewport={{ once: true, amount: 0.2 }}
                  whileHover={{
                    scale: 1.03,
                    boxShadow: "0 8px 20px rgba(0,0,0,0.12)",
                  }}
                  className={styles.postCard}
                >
                  <img src={post.imageUrl || "/placeholder.svg"} alt={post.title} className={styles.otherImage} />
                  <p className={styles.postDate}>{post.date}</p>
                  <Link to={post.link || "#"} style={{ textDecoration: "none" }}>
                    <h3 className={styles.postTitleLink}>{post.title}</h3>
                  </Link>
                </motion.div>
              ))}
            </div>

            {totalOtherPages > 1 && (
              <div className={styles.paginationContainer}>
                <button
                  onClick={() => setOtherPage((prev) => Math.max(prev - 1, 1))}
                  disabled={otherPage === 1}
                  className={styles.paginationButton}
                >
                  <ChevronLeft className="h-5 w-5" />
                  Previous
                </button>
                <span className={styles.paginationInfo}>
                  Page {otherPage} of {totalOtherPages}
                </span>
                <button
                  onClick={() => setOtherPage((prev) => Math.min(prev + 1, totalOtherPages))}
                  disabled={otherPage === totalOtherPages}
                  className={styles.paginationButton}
                >
                  Next
                  <ChevronRight className="h-5 w-5" />
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
      <Footer />
    </div>
  )
}

export default PressRelease